'use client'

import { Text, TextProps } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

export type SectionLabelProps = TextProps & {
  children: ReactNode
}

export const SectionLabel: FC<SectionLabelProps> = ({ children, ...props }) => {
  return (
    <Text
      as="span"
      display="inline-block"
      fontSize="0.8rem"
      fontWeight={600}
      letterSpacing="0.1em"
      textTransform="uppercase"
      color="teal.500"
      mb={4}
      {...props}
    >
      {children}
    </Text>
  )
}
